import apiClient from '@u/apiClient.js'
import GetCondolenceListController from '@/wayfinder/actions/App/Http/Controllers/Condolence/GetCondolenceListController'
import SendAllCondoleancesController from '@/wayfinder/actions/App/Http/Controllers/Condolence/SendAllCondoleancesController'
import SendCondoleanceController from '@/wayfinder/actions/App/Http/Controllers/Condolence/SendCondoleanceController'
import DeleteCondoleanceController from '@/wayfinder/actions/App/Http/Controllers/Condolence/DeleteCondoleanceController'

export default {
  getCondolencesList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(GetCondolenceListController.get(), {
          params: payload.params
        })
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  sendAllCondolences({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(SendAllCondoleancesController.post(), payload.params)
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  sendCondolence({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          SendCondoleanceController.get({ condolence: payload.condolence_id })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  },
  deleteCondolence({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiClient
        .route(
          DeleteCondoleanceController.delete({
            condolence: payload.condolence_id
          })
        )
        .then((response) => {
          resolve(response.data)
        })
        .catch((reason) => {
          reject(reason)
        })
    })
  }
}
